import axios, { AxiosResponse } from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { Gql } from '@fiverr-private/dynamic_matching';

interface Type {
    type: Gql.BuyerType;
}

interface State {
    state: Type;
}

interface Insights {
    insights: State;
}

export const buyerDataUrl = pathfinder('get_dynamic_matching_buyer_data');
export const userIsActiveUrl = pathfinder('get_dynamic_matching_user_is_active');

export const getBuyerData = async (abortController: AbortController): Promise<AxiosResponse<Insights>> =>
    axios.get<Insights>(buyerDataUrl, {
        signal: abortController.signal,
    });

export const getUserIsActive = async (): Promise<AxiosResponse<{ status: string }>> =>
    axios.get<{ status: string }>(userIsActiveUrl);
